module.exports = {
  apiHost: "https://api.serenade.sensoreal.app",
  assetsHost: "https://assets.serenade.sensoreal.app",
  brandName: "Serenade",

  formTemplate: "default",

  currency: {
    locale: "en-AU",
    code: "AUD",
  },

  langs: [{ code: "en", dir: "ltr" }],

  style: {
    primaryColor: "#000",
    textColor: "#fff",
    backgroundColor: "#fff",
    font: "Nexa",
    backgroundGradient: "",
    secondaryFont: "",
    secondaryFontStylesheet: "",
  },

  header: {
    text: {
      en: "Your Serenade Selections",
      ar: "",
    },

    logo: false,
    logoMaxWidth: "",
    logoMaxHeight: "",
    companyLogo: false,
    companyLogoMaxWidth: "",
    companyLogoMaxHeight: "",
    titleFontSize: "",

    color: "#fff",
  },

  footerLogo: false,
  footerLogoPosition: "",
  footerLogoMaxWidth: "",

  links: {
    privacy: "",
    youtube: "",
    linkedin: "",
    twitter: "",
    instagram: "",
    facebook: "",
  },

  contact: {
    website: "",
    address: "",
    phone: "",
    email: "",
  },
};
